import { Button, Collapse, Icon, Modal } from 'antd'

import { getMessage } from '../../../../../../../util/IntlMessages'
import { CustomField } from '../../CustomField'

import './CustomFieldGroup.less'

export function CustomFieldGroup({
  fieldName,
  fields,
  hasFieldErrors,
  renderPanelHeader,
  formValues,
  fieldsById,
  onChangeValue,
  errors,
  isReadOnly,
  isPreview,
  visibleGroups,
  groupType,
  setGroupVisible,
  setGroupHidden,
  isGroupUnderGroup
}) {
  const handleRemoveGroup = () => {
    const hasData = fields.some((field) => {
      const fieldValue = formValues[field.internalFieldName]
      return fieldValue !== undefined && fieldValue !== null && fieldValue !== ''
    })

    if (hasData) {
      return Modal.confirm({
        title: getMessage('confirmRemoveGroupTitle', fieldName),
        content: getMessage('confirmRemoveGroupMessage', fieldName),
        okText: getMessage('confirm'),
        cancelText: getMessage('cancel'),
        onOk: () => setGroupHidden(groupType, fieldName)
      })
    }

    setGroupHidden(groupType, fieldName)
  }

  let newGroupButton = null
  let removeGroupButton = null

  if (isGroupUnderGroup) {
    const { groups, currentIndex } = visibleGroups[groupType]
    const currentGroupIndex = groups.findIndex(({ fieldName: selectedFieldName }) => selectedFieldName === fieldName)
    const isGroupVisible = currentGroupIndex <= currentIndex
    if (!isGroupVisible) return null

    const canAddNewGroup =
      currentIndex === currentGroupIndex && currentGroupIndex < groups.length - 1 && !isReadOnly && !isPreview
    if (canAddNewGroup) {
      newGroupButton = (
        <Button className="CustomFieldGroup__btnAdd" type="ghost" onClick={() => setGroupVisible(groupType, fieldName)}>
          <Icon type="plus" theme="outlined" className="CustomFieldGroup__btnicon" />
          {getMessage('btnAddNewGroupFields', groupType)}
        </Button>
      )
    }

    const canRemoveGroup = currentGroupIndex > 0 && currentIndex === currentGroupIndex && !isReadOnly && !isPreview
    if (canRemoveGroup) {
      removeGroupButton = (
        <Button className="CustomFieldGroup__btnRemove" type="ghost" onClick={handleRemoveGroup}>
          <Icon type="minus" theme="outlined" className="CustomFieldGroup__btnicon" />
          {getMessage('btnRemoveGroupFields', groupType)}
        </Button>
      )
    }
  }

  return (
    <div key={`key_${fieldName}`} id={`key_${fieldName}`}>
      <hr />
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <Icon type="down" rotate={isActive ? -180 : 0} className="CustomFieldGroup__groupCollapseIcon" />
        )}
        {...(hasFieldErrors(fields) ? { activeKey: fieldName } : {})}
      >
        <Collapse.Panel
          className="CustomFieldGroup__groupCollapsePanel"
          header={renderPanelHeader(fieldName, fields)}
          key={fieldName}
        >
          <div className="CustomFieldGroup__group">
            {fields.map((field) => (
              <CustomField
                key={field.id}
                field={field}
                setValues={onChangeValue}
                errors={errors}
                value={formValues[field.internalFieldName]}
                formValues={formValues}
                fieldsById={fieldsById}
                isReadOnly={isReadOnly || isPreview}
                groupFields={fields}
              />
            ))}
          </div>
        </Collapse.Panel>
      </Collapse>

      <div className="CustomFieldGroup__addNewGroupContainer">
        {removeGroupButton}
        {newGroupButton}
      </div>
    </div>
  )
}
